import gsap from 'gsap';


export default class SitelNavs{

    constructor(){
        this._init();
    }


    _init(){
        this.isNavOpen = false;

        this.$header = document.querySelector('.js-header');
        this.$humberger = document.querySelector('.js-header-btn');

        this._ui();
    }


    _ui(){

        window.addEventListener('scroll', ()=>{
            const sx = window.scrollX;
            this.$header.style.left = `${-sx}px`;
        });

        this.$humberger.addEventListener('click', ()=>{
            if(!this.isNavOpen) this._openNav();
            else this._hideNav();
        });

        [...document.querySelectorAll('.l-header__nav__item a')].forEach($link =>{

            $link.addEventListener('click', ()=>{
                this._hideNav();
            });
        });
    }


    _openNav(){
        this.$header.classList.add('-active');
        this.isNavOpen = true;
    }

    _hideNav(){
        this.$header.classList.remove('-active');
        this.isNavOpen = false;
    }
}